import { useReactiveVar } from "@apollo/client";

import {
  EOrganizationType,
  IProViewHome,
  IUnitDetailsDataHome,
} from "../../interfaces/interfaces";
import { getClimateAlertNames, getWarningNames } from "../../utils/alertUtils";
import { organizationIdNameVar } from "../apollo/LocalState";

import UnitCard from "./UnitCard";

const renderFloorName = ({
  floorName,
  moreThanOneFloor,
}: {
  floorName: string;
  moreThanOneFloor: boolean;
}) => {
  if (floorName === "null" && moreThanOneFloor) {
    return <div className="floor-name menu">No floor assigned</div>;
  }
  if (floorName === "null") {
    return null;
  }
  return <div className="floor-name menu">Floor {floorName}</div>;
};

// ProView lists its homes by the homeowner-given `homeName`; MDU units are
// listed by their property name.
type FloorProps = {
  floorName: string;
  moreThanOneFloor: boolean;
} & (
  | { data: IProViewHome[]; showHomeName: true }
  | { data: IUnitDetailsDataHome[]; showHomeName?: false }
);

const Floor: React.FC<FloorProps> = ({
  data,
  floorName,
  moreThanOneFloor,
  showHomeName,
}) => {
  const organizationIdName = useReactiveVar(organizationIdNameVar);
  const namedHomes = showHomeName
    ? data.map((home) => ({ home, name: home.homeName }))
    : data.map((home) => ({ home, name: home.propertyName }));
  return (
    <div className="floor-container">
      {organizationIdName.organizationType !==
        EOrganizationType.PRO_VIEW_ORGANIZATION &&
        renderFloorName({ floorName, moreThanOneFloor })}
      <div className="floor-units">
        {namedHomes.map(({ home: element, name }) => {
          const {
            id,
            alerts,
            isHubless,
            numBrilliantControls,
            numBrilliantPlugs,
            numBrilliantSwitches,
            numIntegrations,
            numResidents,
            numInvitedResidents,
            reconfigurationState,
            warnings,
            subscription,
          } = element;
          const numBrilliants =
            numBrilliantControls + numBrilliantPlugs + numBrilliantSwitches;
          const alertNames = getClimateAlertNames(alerts);
          const warningNames = getWarningNames(warnings);
          return (
            <UnitCard
              key={name}
              isHubless={isHubless}
              propertyId={id}
              alerts={alertNames}
              name={name}
              numBrilliants={numBrilliants}
              numThirdpartyIntegrations={numIntegrations}
              numTenants={numResidents}
              numInvitedResidents={numInvitedResidents}
              reconfigurationState={reconfigurationState}
              warnings={warningNames}
              subscription={subscription}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Floor;
